/**
 * @description Common Store Module
 * @author Fahid Mohammad
 */
import Vue from 'vue';
import http from '../../util/axios';
import i18n from '../../i18n';
import config from '../../config'

export default {
    namespaced: true,
    state: {
        isLoggedIn: false,
        userData: null,
        token: null,
    },
    mutations: {
        SET_LOGGEDIN_STATE: (state, payload) => {
            state.isLoggedIn = payload
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERDATA: (state, data) => {
            state.userData = data
            state.profileCompletion = data.profile_complete
        }
    },
    actions: {
        
        SET_USERDATA ({ commit }, data) {
            commit('SET_USERDATA', data)
        },
        REQUEST_SIGNIN({ commit }, payload) {
            return http.post('/v6/user/signin', payload).then(response => {
                const { status, token, data, desc, message } = response
                if (status == 1001) {
                    return { status: status, message: desc }
                } else if (status == 1003) {
                    return { status: status, message: message }
                } else {
                    Vue.localStorage.set('token', token)
                    commit('SET_LOGGEDIN_STATE', true)
                    commit('SET_TOKEN', token)
                    return { status: status, date: data }
                }
            })
        },
        LOGOUT({ commit }) {
            return new Promise((resolve, reject) => {
                let status = false, token = null;
                Vue.localStorage.remove("token");
                commit('SET_LOGGEDIN_STATE',  status)
                commit('SET_TOKEN', token)
                setTimeout(function () { 
                    resolve(true)
                }, 200)
            })
        },
        REQUEST_USERDATA({ commit }) {
            return http.get('https://phubv3.sanar.sa/v6/user/profile').then(response => {
                const { status, token, data, desc, message } = response
                if (status !== 1000) {
                    return { status: status, message: desc || message }
                } else {
                    commit('SET_USERDATA', data)
                    return { status: status, date: data }
                }
            })
        },
        SET_TOKEN({ commit }, token) {
            commit('SET_TOKEN', token)
            commit('SET_LOGGEDIN_STATE', true)
        }
       
    },
    getters: {
        getToken: state => { return state.token },
        getLoginStatus: state => { return state.isLoggedIn },
        getUserData: state => { return state.userData },
        getUserId: state => { return state.userData.personal.uid },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js